import { motion } from "framer-motion";
import { Countdown } from "./Countdown";
import { useT } from "../lib/prefs";

export const CountdownSection = () => {
  const t = useT();
  return (
  <section className="relative py-20 sm:py-28 overflow-hidden" data-testid="countdown-section">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(109,40,217,0.25),transparent_65%)]" />
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative max-w-3xl mx-auto px-5 sm:px-8"
    >
      <h2 className="font-display font-black uppercase text-3xl sm:text-5xl leading-[0.95] mb-10">
        {t.cdTitleA}<span className="text-gradient">{t.cdTitleB}</span>{t.cdTitleC}
      </h2>
      <Countdown />
    </motion.div>
  </section>
  );
};
